module.exports = __webpack_public_path__ + "static/img/dadi2026Banner1.b9f4c2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/dadi2026Banner1.png
// module id = bG8p
// module chunks = 4